import React from 'react';

import { Icon, TabLinkMenu } from '@swf/sports/components';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import type { InPlayTabs } from '../../model/types';

import styles from './Tabs.scss';

interface Props {
  tabs: InPlayTabs;
  exact?: boolean;
}

const Tabs: React.FC<Props> = ({ tabs, exact }) => (
  <TabLinkMenu>
    {tabs.map(({ name, eventTypeSlug, eventTypeId, count }, i) => (
      <TabLinkMenu.Link
        key={name}
        alias="sportsInPlaySport"
        values={{ eventTypeSlug, eventTypeId }}
        isActive={!exact ? () => i === 0 : undefined}
      >
        <span className={styles.textWrapper}>
          <Icon name={getEventTypeIcon(eventTypeId)} className={styles.icon} size="xl" />
          {name} ({count})
        </span>
      </TabLinkMenu.Link>
    ))}
  </TabLinkMenu>
);

export default Tabs;
